import React from 'react';
import styled, { StylesProps } from '../../../../../lib/styles';
import valuePropositionsBlock_styles from './ValuePropositionsBlock_styles';
import { compose } from 'recompose';
import Spacer from '../../../../../components/presentational/Spacer';
import { BaseBlockProps, ValueProposition } from '../../../../../models/travelCollection';
import ValuePropositions from '../../../../TravelCollection/ValuePropositions';
import valuePropositions_styles from '../../../../TravelCollection/ValuePropositions/ValuePropositions_styles';
import Typography from '../../../../../components/presentational/Typography';

export interface ValuePropositionsBlockData {
  type: 'value_propositions_block';
  usesDefault: boolean;
  title: string;
  subtitle: string;
  valuePropositions: ValueProposition[];
}

export interface ValuePropositionsBlockProps extends BaseBlockProps {
  block: ValuePropositionsBlockData;
}

export const ValuePropositionsBlock = ({
  block: {
    title,
    subtitle,
    valuePropositions,
  },
  isV2Collection = true,
  styles
}: ValuePropositionsBlockProps & StylesProps<typeof valuePropositionsBlock_styles>) => {
  // console.log({isV2Collection, valuePropositions});
  return (
    <div className={`value-propositions-block`}>
        {(title || subtitle) && (
        <Spacer align={'center'}>
          <div className={styles.headingContainer}>
            {title && (
              <Typography>
                <h1>{title}</h1>
              </Typography>
            )}

            {subtitle && (
              <Typography weight={'normal'}>
                <h3>{subtitle}</h3>
              </Typography>
            )}
            </div>
          </Spacer>
        )}
      <ValuePropositions isV2Collection={isV2Collection} valuePropositions={valuePropositions} />
    </div>
  );
};

//  use styles of parent component to allow common formatting
export default compose(
  styled(valuePropositionsBlock_styles),
  styled(valuePropositions_styles)
)(ValuePropositionsBlock);